import * as Constants from './constants'

const initialState = {
  list: [],
  item: {},
  type: Constants.LS_TRATHUONG_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: []
}

const reducer = function traDiemReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.LS_TRATHUONG_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.LS_TRATHUONG_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.LS_TRATHUONG_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    
    case Constants.LS_TRATHUONG_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.LS_TRATHUONG_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.LS_TRATHUONG_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.LS_TRATHUONG_REMOVE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.LS_TRATHUONG_REMOVE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.LS_TRATHUONG_REMOVE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/LichSuTraThuong/reducer.js